<template>
	<div class="started_wrapper">
		<div class="download">
			<ul>
				<li>
					<ac></ac>
				</li>
			</ul>
		</div>
    <step-status :step="$route.meta.step" class="mt55"></step-status>
		<div class="started_container">
			<img src="~@img/stared_bird.png" alt="bird">
			<h1>Congratulations!</h1>
			<p class='words'>You're ready to become a HAWO teacher. We're excited to have you on our team, and we hope that you'll enjoy your experience with us!
			</p>
			<a class='started' @click='letUsBegin'>Let's get started!</a>
			<p class='msg'>Please click on the button below to launch.</p>
		</div>
	</div>
</template>

<script>
import ac from '@common/ac'
import { urls } from '@js'

export default {
  data() {
    return {
      isMac: false,
      isWindows: false
    }
  },
  components: {
    ac
  },
  methods: {
    letUsBegin() {
      this.$http
        .get('/boarding/setStartBtnStatus') //最后一步向服务器打点，记录用户状态
        .then(d => {
          if (d.data.code == '75000') {
            window.location.href = urls.myPageLogTea
          } else {
            this.$message.error(d.data.message)
          }
        })
    }
  }
}
</script>

<style lang='less'>
.started_wrapper {
  width: 1000px;
  margin: 0 auto;
  .download {
    position: fixed;
    top: 166px;
    right: 80px;
    & > ul {
      width: 75px;
      li {
        float: left;
        margin-top: 6px;
        background-color: #fff;
        border-radius: 5px;
      }
    }
  }
  & > img {
    margin-top: 58px;
  }
  .started_container {
    margin-top: 50px;
    text-align: center;
    height: 552px;
    & > h1 {
      margin-top: 20px;
      font-size: 30px;
      font-weight: bold;
      color: #fd4c6e;
    }
    p.words {
      margin-top: 28px;
      font-size: 16px;
      color: #525252;
    }
    a.started {
      display: block;
      cursor: pointer;
      margin: 0 auto;
      margin-top: 56px;
      width: 337px;
      height: 46px;
      line-height: 46px;
      text-align: center;
      font-size: 24px;
      color: #1e1e1e;
      background: #fcc800;
      border-radius: 10px;
    }
    p.msg {
      margin-top: 15px;
      font-size: 14px;
      color: #999999;
    }
  }
}
</style>


// WEBPACK FOOTER //
// get_started.vue?99dc41b0